import OrganizationDelete from '@/screens/OrganizationDelete';

export default function OrganizationDeleteRoute() {
  return <OrganizationDelete />;
}
